// extracted by mini-css-extract-plugin
module.exports = {"root":"ColorPicker_root__cpIla","backgroundIndicator":"ColorPicker_backgroundIndicator__cSyi_","options":"ColorPicker_options__fKXmb","palette":"ColorPicker_palette__aoZnK"};